// Class: swf.exporters.swflite.StaticTextRecord

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var StaticTextRecord = function() {
}

// Meta

StaticTextRecord.__name__ = "swf.exporters.swflite.StaticTextRecord";
StaticTextRecord.__isInterface__ = false;
StaticTextRecord.prototype = {
	
};
StaticTextRecord.prototype.__class__ = StaticTextRecord.prototype.constructor = $hxClasses["swf.exporters.swflite.StaticTextRecord"] = StaticTextRecord;

// Init



// Statics




// Export

exports.default = StaticTextRecord;